import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { ZoneService } from './zone.service';
@Component({
  selector: 'app-zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.scss']
})
export class ZoneComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'zone_name', 'zone_code', 'country', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  zoneForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private zoneService: ZoneService) {
    this.zoneForm = this.fb.group({
      zoneName: ['', Validators.required],
      zoneCode: [''],
      country: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getCountryList();
  }

  get f() { return this.zoneForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.zoneForm.patchValue({
      zoneName: object.zone_name,
      zoneCode:object?.zone_code,
      country: object.country.id,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  create() {
    this.submitted = true
    if (this.zoneForm.valid) {
      const zoneData = this.zoneForm.value;
      let obj = {
        "zone_name": zoneData.zoneName,
        "zone_code": zoneData.zoneCode,
        "country_id": zoneData.country,
        "status": parseInt(zoneData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.zoneService.createZone(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Zone created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.zoneForm.valid) {
      const zoneData = this.zoneForm.value;
      let obj = {
        "zone_name": zoneData.zoneName,
        "zone_code": zoneData.zoneCode,
        "country_id": zoneData.country,
        "status": parseInt(zoneData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.zoneService.updateZone(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Zone updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.zoneForm.patchValue({
      zoneCode: '',
      zoneName: '',
      country: '',
      status: ''
    });
  }

  allowNumbersHyphenOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9\-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.zoneService.getZone().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  countryList: any = []
  getCountryList() {
    this.zoneService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.countryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }
}
